__webpack_require__.p = "https://checkout-x1.snapmint.com/";